export default __webpack_public_path__ + "static/media/2.9dd4e0ac.webp";